export const MATCH_SYNC_REPLICANT = "matchSync";

export type MatchSyncStep = "pfl" | "standings" | "mapping" | "stats";

export type MatchSyncError = { step: MatchSyncStep; message: string; since: number };

export type MatchSyncDostats = {
  matchLinked: boolean;
  /** dostats has published a lineup for the match. */
  lineupReady: boolean;
  unmappedStarters: number;
};

export type MatchSyncStatus = {
  lastRunAt: number;
  lastOkAt: number | null;
  errors: MatchSyncError[];
  dostats: MatchSyncDostats | null;
};

/** Per project slug; only projects inside the match-day poll window. */
export type MatchSyncReplicant = Record<string, MatchSyncStatus>;
